import axios from 'axios';
import poliConfig from '../../utils/poliConfig';

const defaultHeaders = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
};

const defaultConfig = {
  headers: defaultHeaders,
  withCredentials: true,
};

let LARAVEL_URL = poliConfig.poliAppLaravelUrl ?? '';

const postEmbedUrl = async (data, url) => {
  if (url) {
    LARAVEL_URL = url;
  }

  const response = await axios.post(`${LARAVEL_URL}/metabase/embed-url`, data, defaultConfig);
  return response.data;

};

export {
  postEmbedUrl
};
